import { Component, OnInit } from '@angular/core';
import {UserService} from '../user.service';
import {Router} from '@angular/router';

@Component({
  selector: 'global-main-nav',
  templateUrl: './global-main-nav.component.html'
})
export class GlobalMainNavComponent implements OnInit {

      constructor(
    private userService: UserService,
    private router: Router,
  ) {}

	ngOnInit() {
	}


	logout() {
            this.userService.fullname = '';
            this.userService.user = null;
            this.router.navigate(['/']);
        }



}


// WEBPACK FOOTER //
// ./src/app/global-main-nav/global-main-nav.component.ts